export const styles = {
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    showMoreTags: {
        border: 'none',
        backgroundColor: 'transparent',
        color: '#3da2fc',
        fontSize: '11px',
        display: 'block',
        width: '100%',
        textAlign: 'left',
        marginTop: '10px',
        cursor: 'pointer',

        ['&:hover']: {
            color: '#2087ff',
        }
    }
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
